// extracted by mini-css-extract-plugin
export var container = "_60-0";
export var error = "_60-9";
export var label = "_60-5";
export var light = "_60-6";
export var md = "_60-3";
export var sm = "_60-2";
export var thin = "_60-8";
export var thinBold = "_60-7";
export var vertical = "_60-4";
export var xs = "_60-1";